import {
  interpolate,
  interpolateColor,
  SharedValue,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated'
import cn from '@ui/utils/cn'
import { leadingNone } from '@ui/typography/styles'
import { colors } from '@ui/colors'
import Typography from '@ui/typography'
import { View } from 'react-native'

interface Props {
  text: string
  isDisabled: boolean
  animation: SharedValue<number>
  selection: SharedValue<number>
  index: number
}

export default function SegmentedOption({
  text,
  isDisabled,
  animation,
  selection,
  index,
}: Props) {
  // Active label peaks when the indicator is over this item, gated by `selection`
  // so all labels go inactive when nothing is selected. Inactive is the complement.
  const styleTextActive = useAnimatedStyle(() => {
    const active =
      interpolate(animation.value, [index - 1, index, index + 1], [0, 1, 0]) *
      selection.value
    return {
      color: isDisabled ? colors.black25 : colors.white,
      opacity: active,
    }
  })

  const styleTextInactive = useAnimatedStyle(() => {
    const active =
      interpolate(animation.value, [index - 1, index, index + 1], [0, 1, 0]) *
      selection.value
    return {
      color: isDisabled ? colors.black25 : colors.text75,
      opacity: 1 - active,
    }
  })

  return (
    <View className="relative">
      <Typography
        variant="SMB"
        style={styleTextActive}
        className={cn(leadingNone, 'font-text-semibold select-none px-4')}
      >
        {text}
      </Typography>
      <Typography
        variant="SMB"
        style={styleTextInactive}
        className={cn(
          leadingNone,
          'font-text-semibold absolute select-none px-4'
        )}
      >
        {text}
      </Typography>
    </View>
  )
}
